export const seekerAddresses = [
    "6SYd8tyH71yoQy57PhyrBrveZoSm7Rh4yRwp3LfqAN83"
]
